export enum FileTypes {
  STL_L = 2,
  STL_R = 3,
  MATAMX_L = 9,
  MATAMX_R = 10
}
